<div class="bk-dialog bk-dialog__event">

    <button class="bk-modal__close_btn"
		(click)="onClose()"
		type="button">
		<mat-icon>close</mat-icon>
	</button>
    
    <h4 mat-dialog-title>
        {{'Recommendation Summary' | translate}}
    </h4>

    <div mat-dialog-content>
		 <fertilization-recommendation-summary
			[nInWater]="nInWater">
		</fertilization-recommendation-summary>
	</div>

	<!-- footer -->

    <div mat-dialog-actions align="end">

		<button mat-button
			class="bk-button bk-button--medium"
			[disabled]=""
			type="button"
			(click)="onClose()">
			{{'Close' | translate }}
		</button>
    </div>
</div>